module.exports = __webpack_public_path__ + "static/monikawork4-ab8e884cb379695213ae7163590d78a3.jpg";